<app-header></app-header>

<div class="container-fluid" style="width: 80%">
    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item">
                        <a href="/home">Home</a><span class="separator">/</span>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="/anagrafiche-professionisti">Anagrafiche professionisti</a><span class="separator">/</span>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Dettaglio operatore
                    </li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Dettaglio operatore</h4>
        </div>
    </div>

    <div *ngIf="!loading && operatore; else spinner">
        <div class="row g-4">
            <div class="col-md-7">
                <mat-card appearance="outlined" class="h-100">
                    <mat-card-header>
                        <mat-icon mat-card-avatar color="primary">account_circle</mat-icon>
                        <mat-card-title>Dati Anagrafici</mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="mt-4">
                        <div class="info-row">
                            <span class="label">Nominativo:</span>
                            <span class="value text-uppercase"><b>{{operatore.cognome}} {{operatore.nome}}</b></span>
                        </div>

                        <div class="info-row" *ngIf="operatore.codiceFiscale">
                            <span class="label">Codice Fiscale</span>
                            <span class="value d-flex align-items-center gap-2">
                                <code>{{operatore.codiceFiscale}}</code>
                                <button mat-icon-button [cdkCopyToClipboard]="operatore.codiceFiscale"
                                    matTooltip="Copia Codice Fiscale" class="copy-btn">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </span>
                        </div>

                        <div class="info-row" *ngIf="operatore.dataNascita">
                            <span class="label">Data di Nascita:</span>
                            <span class="value">{{operatore.dataNascita | date:'dd/MM/yyyy'}}</span>
                        </div>

                        <div class="info-row" *ngIf="operatore.luogoNascita">
                            <span class="label">Luogo di Nascita:</span>
                            <span class="value">{{operatore.luogoNascita}}</span>
                        </div>

                        <mat-divider class="my-2"></mat-divider>

                        <div class="info-row" *ngIf="operatore.email">
                            <span class="label">Email:</span>
                            <span class="value">{{operatore.email}}</span>
                        </div>
                        <div class="info-row" *ngIf="operatore.cellulare">
                            <span class="label">Cellulare:</span>
                            <span class="value">{{operatore.cellulare}}</span>
                        </div>
                        <div class="info-row" *ngIf="operatore.telefonoFisso">
                            <span class="label">Tel. Fisso:</span>
                            <span class="value">{{operatore.telefonoFisso}}</span>
                        </div>

                        <mat-divider class="my-2"
                            *ngIf="operatore.luogoResidenza || operatore.distrettoResidenza"></mat-divider>

                        <div class="info-row" *ngIf="operatore.luogoResidenza">
                            <span class="label">Residenza:</span>
                            <span class="value">{{operatore.luogoResidenza}}</span>
                        </div>
                        <div class="info-row" *ngIf="operatore.distrettoResidenza">
                            <span class="label">Distretto:</span>
                            <span class="value">{{operatore.distrettoResidenza}}</span>
                        </div>

                        <mat-divider class="my-2" *ngIf="operatore.cfMedico || operatore.codiceMedico"></mat-divider>

                        <div class="info-row" *ngIf="operatore.cfMedico">
                            <span class="label">CF Medico:</span>
                            <span class="value">{{operatore.cfMedico}}</span>
                        </div>
                        <div class="info-row" *ngIf="operatore.codiceMedico">
                            <span class="label">Codice Medico:</span>
                            <span class="value">{{operatore.codiceMedico}}</span>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-md-5">
                <mat-card appearance="outlined" class="mb-4">
                    <mat-card-header>
                        <mat-icon mat-card-avatar color="accent">workspace_premium</mat-icon>
                        <mat-card-title>Qualifiche</mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="mt-3">
                        <mat-chip-set>
                            <mat-chip *ngFor="let q of operatore.qualifiche" (click)="openCalendario(q.id)"
                                class="clickable-chip">
                                {{ q.descrizione }}
                            </mat-chip>
                        </mat-chip-set>
                    </mat-card-content>
                </mat-card>

                <mat-card appearance="outlined">
                    <mat-card-header><mat-card-title>Strutture</mat-card-title></mat-card-header>
                    <mat-card-content class="mt-2">
                        <div *ngFor="let s of operatore.strutture"
                            class="d-flex justify-content-between align-items-center p-2 border-bottom hover-row">
                            <span><b>{{s.denominazione}}</b></span>

                            <button mat-icon-button (click)="openStrutturaDetail(s)" matTooltip="Dettagli Struttura"
                                color="primary">
                                <mat-icon>info_outline</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="!operatore.strutture?.length" class="text-muted small p-2">
                            Nessuna struttura associata
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

    <ng-template #spinner>
    </ng-template>
</div>

<app-footer></app-footer>